import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Free.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
  AiFillMail,
} from "react-icons/ai";
import { FaWhatsapp } from "react-icons/fa"; 

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              <span className="purple"> INTRODUÇÃO </span>
            </h1>
            <p className="home-about-body">
              Bem-vindo à{" "}
              <span className="purple">
                <b>Quantum Tech</b>
              </span>
              , especialista em{" "}
              <span className="purple">sistemas de gestão empresarial e e-commerce</span>. 
              Nossa missão é transformar a maneira como você gerencia e vende, com soluções 
              completas que integram gestão operacional e vendas online.
              <br />
              <br />
              Nossas soluções para <span className="purple">gestão empresarial</span> incluem:
              <br />
              - Controle financeiro e contábil
              <br />
              - Gestão de estoque integrada
              <br />
              - CRM e acompanhamento de clientes
              <br />
              - Emissão automática de documentos fiscais
              <br />
              - Business Intelligence para decisões estratégicas
              <br />
              <br />
              E para <span className="purple">e-commerce</span>, desenvolvemos:
              <br />
              - Lojas virtuais completas e responsivas
              <br />
              - Integração com marketplaces e redes sociais
              <br />
              - Sistemas de pagamento seguro
              <br />
              - Gestão automatizada de pedidos
              <br />
              - Ferramentas de marketing digital integradas
              <br />
              <br />
              Na <span className="purple">
                <b>Quantum Tech</b>
              </span>{" "}
              unimos o melhor dos dois mundos: a eficiência da gestão empresarial 
              com o poder das vendas online, criando um ecossistema completo para 
              seu negócio crescer de forma organizada e escalável.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>NOSSAS REDES</h1>
            <p>
              Seja livre para se <span className="purple">conectar </span>conosco
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://wa.me/5519998830413" 
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaWhatsapp /> 
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:contato.quantumtechbrasil@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillMail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/quantumtech_brasil/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;